import React, { useState } from 'react'
import { reduxForm } from 'redux-form'
import { formatDateToDisplayString } from 'app/utils/dateTimeUtils'
import LgyField from 'app/components/util/lgy-field/LgyField'

function ValidationExpirationDateForm({ validationExpirationDate, newExpirationDate, setNewExpirationDate, validationExpirationDatePlus90Days, simValidationExpirationDate, pristine, submitting, reset, handleSubmit }) {
  const [isShown, setIsShown] = useState(false);
  const [simExpDate, setSimExpDate] = useState(false);

  return (
    <div className='validation-expiration-date-form'>
      <form onSubmit={handleSubmit}>
        <LgyField label='Validation Expiration Date' value={formatDateToDisplayString(new Date(validationExpirationDate))} />
        <span style={{ 'display': 'inline-block' }}>
          {isShown &&
            <LgyField
              label='New Validation Expiration Date Would Be'
              value={formatDateToDisplayString(new Date(simExpDate ? simValidationExpirationDate : validationExpirationDatePlus90Days))} />}
        </span>
        <div style={{ 'display': 'grid', 'max-width': 'max-content' }}>
          {simValidationExpirationDate ? <button
            onMouseEnter={() => { setIsShown(true); setSimExpDate(true); setNewExpirationDate(simValidationExpirationDate) }}
            onMouseLeave={() => setIsShown(false)}
            type='submit'
            disabled={!validationExpirationDate || submitting}>Set to SIM Validation Expiration Date</button> : null}
          <button
            onMouseEnter={() => { setIsShown(true); setSimExpDate(false); setNewExpirationDate(validationExpirationDatePlus90Days) }}
            onMouseLeave={() => setIsShown(false)}
            type='submit'
            disabled={!validationExpirationDate || submitting}>Extend Expiration Date 90 Days</button>
        </div>
      </form>
    </div>)
}
export default reduxForm({})(ValidationExpirationDateForm)